import type { CSSProperties } from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={4000}
      // Sonner's default 356px is narrow for two-line messages carrying an
      // action button; the toast itself just fills the container.
      style={{ '--width': '440px' } as CSSProperties}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex items-center gap-3 w-full rounded-xl border-2 border-border px-4 py-3 font-body text-sm shadow-hard-sm animate-toast-enter',
          title: 'font-semibold',
          description: 'text-muted-foreground text-xs',
          // `unstyled` strips sonner's own action styling too, so give the
          // button a brand look — it is shared by every toast variant.
          actionButton:
            'ml-auto shrink-0 cursor-pointer rounded-lg border-2 border-foreground bg-foreground px-2.5 py-1 font-display text-xs font-semibold text-background',
          success:
            'bg-riso-teal-light text-foreground border-riso-teal shadow-[4px_4px_0_var(--riso-teal)]',
          // Sonner's icons are `fill: currentColor`, so they inherit the toast
          // text colour unless the variant recolours the `[data-icon]` wrapper.
          error:
            'bg-[#fff0f0] text-foreground border-destructive shadow-[4px_4px_0_hsl(var(--destructive))] [&_[data-icon]]:text-destructive',
          warning:
            'bg-riso-amber-light text-foreground border-riso-amber shadow-[4px_4px_0_var(--riso-amber)]',
          info: 'bg-riso-blue-light text-foreground border-riso-blue shadow-[4px_4px_0_var(--riso-blue)]',
        },
      }}
    />
  );
}

export { Toaster, toast };
